import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { usePermissions } from '../hooks/usePermissions';
import Navbar from '../components/Navigation/Navbar';

const Unauthorized = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { role, permissions } = usePermissions();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Navbar />
      <div className="flex items-center justify-center min-h-screen">
        <div className="max-w-md w-full bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8 text-center">
          <div className="text-red-500 text-6xl mb-4">🚫</div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
            {t('unauthorized.accessDenied')}
          </h1>
          <p className="text-gray-600 dark:text-gray-300 mb-6">
            {t('unauthorized.noPermission')}
          </p>
          
          {user && (
            <div className="bg-gray-100 dark:bg-gray-700 rounded-lg p-4 mb-6">
              <h3 className="font-semibold text-gray-900 dark:text-white mb-2">
                {t('unauthorized.currentAccessLevel')}
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-300 mb-2">
                <strong>{t('unauthorized.role')}:</strong> {role || t('unauthorized.roleNotAssigned')}
              </p>
              <p className="text-sm text-gray-600 dark:text-gray-300">
                <strong>{t('unauthorized.permissions')}:</strong> {permissions.length > 0 ? permissions.length : t('unauthorized.permissionsNone')}
              </p>
            </div>
          )}
          
          <div className="space-y-3">
            <Link
              to="/"
              className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded transition-colors"
            >
              {t('unauthorized.goToHome')}
            </Link>
            <Link
              to="/profile"
              className="w-full bg-gray-600 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded transition-colors"
            >
              {t('unauthorized.viewProfile')}
            </Link>
          </div>
          
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-6">
            {t('unauthorized.contactAdmin')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
